<script lang="ts" setup>
import { Comment, computed, type VNode } from 'vue';

import KaTableCell from './KaTableCell.vue';
import { injectSkeletonRowContext, injectTableContext } from './model';

const { isSmall, isZebra } = injectTableContext();
const { index } = injectSkeletonRowContext();

const slots = defineSlots<{
  default(index: number): VNode[];
}>();

const nodesList = computed(() =>
  // Filter out v-if="false" nodes
  slots.default(index.value).filter((node) => node.type !== Comment),
);
</script>
<template>
  <tr
    role="presentation"
    class="group/row"
    :class="{
      'odd:bg-gray-50 odd:dark:bg-navy-900/90 dark:even:bg-navy-900/40': isZebra,
      'h-[40px]': isSmall,
      'h-[45px]': !isSmall,
    }"
  >
    <KaTableCell
      v-for="(columnNode, columnIndex) in nodesList"
      :key="columnIndex"
      role="presentation"
    >
      <component :is="columnNode" />
    </KaTableCell>
  </tr>
</template>
